import { Button } from "@components/common/button"
import { BarChart3, RefreshCw } from "lucide-react"

export function EmptyState({
  translate,
  isHebrew,
  onRetry,
}: {
  translate: (key: string) => string
  isHebrew: boolean
  onRetry: () => void
}) {
  return (
    <div
      className='flex flex-col items-center justify-center py-24 text-center'
      dir={isHebrew ? "rtl" : "ltr"}
    >
      <div className='mb-5 flex h-20 w-20 items-center justify-center rounded-2xl border border-gray-100 bg-gray-50 shadow-sm'>
        <BarChart3 className='h-10 w-10 text-gray-300' />
      </div>
      <h3 className='mb-1 text-lg font-semibold text-gray-900'>{translate("No Task Data")}</h3>
      <p className='mb-6 max-w-xs text-sm leading-relaxed text-muted-foreground'>
        {translate("Create tasks to see analytics")}
      </p>
      <Button
        variant='outline'
        size='sm'
        onClick={onRetry}
        className='gap-2'
        aria-label={translate("Retry")}
      >
        <RefreshCw className='h-4 w-4' />
        {translate("Retry")}
      </Button>
    </div>
  )
}
